'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { universities } from '../data/universities';

type NavItem = {
  href: string;
  label: string;
};

type Props = {
  items: NavItem[];
};

export function StudentsNav({ items }: Props) {
  const pathname = usePathname();

  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-4 sm:px-6 lg:px-8">
      <div className="flex flex-wrap gap-2">
        {items.map((item) => {
          const isActive = pathname === item.href || pathname.startsWith(`${item.href}/`);

          return (
            <Link
              key={item.href}
              href={item.href}
              className={`rounded-full border px-4 py-2 text-sm font-semibold transition ${
                isActive
                ? 'border-sky-300/60 bg-sky-400/15 text-main dark:text-sky-100'
                : 'border-white/25 bg-white/15 text-white hover:border-white/35 hover:bg-white/20 dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-200 dark:hover:border-slate-500 dark:hover:bg-slate-700/70'
              }`}
            >
              {item.label}
            </Link>
          );
        })}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-100/90 dark:text-slate-400">
          Вузы:
        </span>
        {universities.map((university) => {
          const href = `/students/universities/${university.slug}`;
          const isActive = pathname === href;

          return (
            <Link
              key={university.slug}
              href={href}
              className={`rounded-full border px-3 py-1 text-xs font-semibold transition ${
                isActive
                ? 'border-sky-300/60 bg-sky-400/15 text-main dark:text-sky-100'
                : 'border-white/25 bg-white/15 text-white hover:bg-white/20 dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-200/90 dark:hover:bg-slate-700/70'
              }`}
            >
              {university.shortName}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
